













































































































import { Component, Watch } from 'vue-property-decorator';
import { Components } from '@baklavajs/plugin-renderer-vue';
import ArrowButton from '@/inputs/ArrowButton.vue';
import { ModelNodes } from '@/nodes/model/Types';
import IrError from '@/app/ir/checking/irError';
import { Getter } from 'vuex-class';
import { Severity } from '@/app/ir/checking/severity';
import { OverviewNodes } from '@/nodes/overview/Types';
import { CommonNodes } from '@/nodes/common/Types';
import { DataNodes } from '@/nodes/data/Types';

@Component({
  components: { ArrowButton },
})
export default class CustomNode extends Components.Node {
  @Getter('errorsMap') errorsMap!: Map<string, IrError[]>;
  private shouldShowOptions = true;

  contextMenu = {
    show: false,
    x: 0,
    y: 0,
    items: this.getContextualMenuItems(),
  };

  private currentErrors: IrError[] = [];

  private customNode = CommonNodes.Custom;

  get messages(): string | undefined {
    return this.currentErrors.length !== 0
      ? this.currentErrors.map((e) => e.formattedMessage).reduce((prev, curr) => `${prev}\n${curr}`)
      : undefined;
  }

  get severity(): Severity[] {
    const index = (s: Severity) => Object.keys(Severity).indexOf(s);
    return this.currentErrors.map((e) => e.severity).sort((a, b) => index(a) - index(b));
  }

  private showErrorMessages = false;

  setShowErrorMessages(show: boolean) {
    this.showErrorMessages = show;
  }

  get shading() {
    const severities = this.severity;
    if (severities.length === 0) {
      return this.selected
        ? { 'box-shadow': '0 0 0px 2px var(--blue)' }
        : { 'box-shadow': '0 0 0px 1px var(--black)' };
    }
    switch (severities[0]) {
      case Severity.Error:
        return this.selected
          ? { 'box-shadow': '0 0 1px 4px var(--red)' }
          : { 'box-shadow': '0 0 1px 2px var(--red)' };
      case Severity.Warning:
        return this.selected
          ? { 'box-shadow': '0 0 1px 3px var(--yellow)' }
          : { 'box-shadow': '0 0 1px 1px var(--yellow)' };
      default:
        return {};
    }
  }

  @Watch('errorsMap')
  private onErrorsUpdate(errorsMap: Map<string, IrError[]>) {
    this.currentErrors = errorsMap.get(this.data.id) || [];
  }

  private getContextualMenuItems() {
    const items = [{ value: 'delete', label: 'Delete' }];
    if (this.data.type !== OverviewNodes.ModelNode
      && this.data.type !== OverviewNodes.DataNode
      && this.data.type !== CommonNodes.Custom) {
      items.unshift({ value: 'rename', label: 'Rename' });
    }
    return items;
  }

  private toggleShouldShowOptions(): void {
    this.shouldShowOptions = !this.shouldShowOptions;
  }

  get titleBackground() {
    switch (this.data.type) {
      case ModelNodes.Conv1d:
      case ModelNodes.Conv2d:
      case ModelNodes.Conv3d:
      case ModelNodes.ConvTranspose1d:
      case ModelNodes.ConvTranspose2d:
      case ModelNodes.ConvTranspose3d:
      case OverviewNodes.ModelNode:
      case DataNodes.ToTensor:
      case DataNodes.Grayscale:
        return { background: 'var(--blue)' };
      case ModelNodes.MaxPool1d:
      case ModelNodes.MaxPool2d:
      case ModelNodes.MaxPool3d:
      case OverviewNodes.Adadelta:
        return { background: 'var(--red)' };
      case ModelNodes.Dropout:
      case ModelNodes.Dropout2d:
      case ModelNodes.Dropout3d:
      case OverviewNodes.DataNode:
        return { background: 'var(--pink)' };
      case ModelNodes.Relu:
      case ModelNodes.Softmax:
      case ModelNodes.Softmin:
        return { background: 'var(--green)' };
      case ModelNodes.InModel:
      case ModelNodes.OutModel:
      case DataNodes.OutData:
      case OverviewNodes.TrainClassifier:
        return { background: 'var(--purple)' };
      case ModelNodes.Linear:
      case ModelNodes.Bilinear:
        return { background: 'var(--mustard)' };
      case ModelNodes.Transformer:
        return { background: 'var(--seafoam)' };
      case CommonNodes.Custom:
        return { background: 'var(--foreground)', color: 'var(--dark-grey)' };
      default:
        return { background: 'var(--black)' };
    }
  }
}
